import { render, staticRenderFns } from "./BulkRulesEdit.vue?vue&type=template&id=502ac0f4&scoped=true&"
import script from "./BulkRulesEdit.vue?vue&type=script&lang=js&"
export * from "./BulkRulesEdit.vue?vue&type=script&lang=js&"
import style0 from "./BulkRulesEdit.vue?vue&type=style&index=0&id=502ac0f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502ac0f4",
  null
  
)

export default component.exports